<script>
	// One saved goods-return certificate, as it prints.
	import { onMount } from 'svelte';
	import { push } from 'svelte-spa-router';
	import fetchData from '../../api.js';
	import UserStore from '../../stores/user';
	import AppShell from '../../components/AppShell.svelte';
	import Icon from '../../components/Icon.svelte';
	import ReturnPrint from '../../components/ReturnPrint.svelte';

	export let params = {};

	let note = null;
	let loading = true;
	let error = '';
	let deleting = false;

	$: isAdmin = $UserStore.role === 'admin';
	$: date = note ? new Date(String(note.created_at).replace(' ', 'T')).toLocaleDateString('he-IL') : '';

	async function remove() {
		if (!confirm('למחוק את תעודת ההחזרה מס׳ ' + note.id + ' של ' + note.customer_name + '?')) return;
		deleting = true;
		const res = await fetchData({ action: 'agents_return_note_delete', token: $UserStore.data, id: note.id });
		deleting = false;
		if (res && Number(res.success) === 1) push('/agents/return-notes');
		else alert((res && res.msg) || 'המחיקה נכשלה');
	}

	onMount(async () => {
		if (!$UserStore || !$UserStore.data) {
			push('/login');
			return;
		}
		const res = await fetchData({ action: 'agents_return_note', token: $UserStore.data, id: Number(params.id) });
		if (res && Number(res.success) === 1) note = res.data;
		else error = (res && res.msg) || 'אין חיבור לשרת';
		loading = false;
	});
</script>

<AppShell title="תעודת החזרה">
	<div class="toolbar">
		<a class="back" href="#/agents/return-notes">→ לכל התעודות</a>
		{#if note}
			<span class="grow" />
			{#if isAdmin}<button class="btn-danger-text" on:click={remove} disabled={deleting}>מחיקת תעודה</button>{/if}
			<button class="btn-primary" on:click={() => window.print()}><Icon name="receipt" size={20} /> הדפסה</button>
		{/if}
	</div>

	{#if loading}
		<div class="spinner" />
	{:else if error}
		<div class="alert-error">{error}</div>
	{:else}
		<ReturnPrint
			paper
			title="תעודת החזרת סחורה"
			number={note.id}
			{date}
			company={$UserStore.company || ''}
			agent={note.agent_name || ''}
			customerName={note.customer_name}
			customerNo={note.customer_no}
			remarks={note.remarks}
			cartons={Number(note.cartons) || 0}
			items={note.items.map((i) => ({ code: i.model, name: i.model_name, qty: Number(i.qty), price: Number(i.price), doc_no: i.source_doc_no, date: i.source_date }))}
			note="מחיר ליחידה: המחיר האחרון ששילם הלקוח על הדגם, אחרי הנחת שורה והנחה כללית, לפני מע״מ."
		/>
	{/if}
</AppShell>

<style>
	.toolbar { display: flex; align-items: center; gap: 12px; margin-bottom: 16px; max-width: 960px; margin-inline: auto; }
	.back { color: var(--ink-2); font-size: 16px; text-decoration: underline; min-height: 44px; display: flex; align-items: center; }
	.grow { flex: 1; }
</style>
